
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-cookie-notice-dialog',
    imports: [],
    templateUrl: './cookie-notice-dialog.component.html',
    styleUrls: ['./cookie-notice-dialog.component.scss']
})
export class CookieNoticeDialogComponent {
  @Output() modalAgree: EventEmitter<void> = new EventEmitter();
  @Output() modalCancel: EventEmitter<void> = new EventEmitter();

  agree() {
    this.modalAgree.emit();
  }

  close() {
    this.modalCancel.emit();
  }
}
